// extracted by mini-css-extract-plugin
export default {"error":"PageError_error__1EWRf"};